import classNames from 'classnames';
import { Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { LevelUpSelect } from '~/components/LevelUp/Card/Select/LevelUpSelect';
import levelUpCardStyles from '../LevelUpCard.module.scss';
import styles from './LevelUpSelectCard.module.scss';

export const LevelUpSelectCard = () => (
  <BaseCard className={classNames(styles.root, levelUpCardStyles.root)} shadow size="large">
    <div className={styles.header}>
      <Heading className={styles.title} level={5}>
        <T name="citizen_membership_levelup_sec1_title" />
      </Heading>
      <p className={classNames(styles.description, levelUpCardStyles.description)}>
        <T name="citizen_membership_levelup_sec1_desc1" />
      </p>
    </div>
    <div className={styles.body}>
      <LevelUpSelect />
    </div>
  </BaseCard>
);
